import { HealthlinkSubmissionStatus } from "features/healthlink/components/HealthlinkSubmissionStatus/HealthlinkSubmissionStatus";
import { formatDate } from "utils/dateFormatter";

import { LabOrderStatusPill } from "../LabOrderStatusPill/LabOrderStatusPill";

// Maps an order onto the shared Healthlink submission section. The reference matters
// more here than it does elsewhere: it is the OCN the laboratory's order slip barcode
// carries, so it is what a GP quotes on the phone.
export const LabOrderHealthlinkStatus = ({ order }) => {
  if (!order) return null;

  return (
    <HealthlinkSubmissionStatus
      statusPill={<LabOrderStatusPill order={order} />}
      submitted={formatDate(order.created)}
      lastUpdate={formatDate(order.updated)}
      acknowledgement={order.acknowledgementCode}
      messageId={order.messageControlId}
      messageIdLabel="Order reference:"
    />
  );
};
